export default __webpack_public_path__ + "7f5df8f1b1aa82d1f9e66f0abee8b3aa.png";